// eslint-disable @typescript-eslint/naming-convention
import type { track as TrackType } from "pro-features/components/WithTrack/src/context";
import type { BenchmarkTabName } from "app/pages/benchmark-tracker/config";
import type { BenchmarkGranularity } from "app/pages/benchmark-tracker/services/api/constants";
import { allTrackers } from "app/services/track/track";

type ReportTrackingEntity = {
    trackTabSelection(tabName: BenchmarkTabName): void;
    trackConnectGAModalOpen(): void;
    trackEditOpen(): void;
    trackPdfDownload(): void;
    openSubscriptionModal(isOwner: boolean): void;
    cancelSubscriptionModal(isOwner: boolean): void;
    confirmSubscriptionModal(frequency: BenchmarkGranularity, isOwner: boolean): void;
    unsubscribeFromDigest(isOwner: boolean): void;
};

export const createReportTracking = (track: TrackType): ReportTrackingEntity => ({
    trackTabSelection(tabName: BenchmarkTabName) {
        track("Tabs", "select", tabName);
    },
    trackConnectGAModalOpen() {
        track("GA Modal", "open", "");
    },
    trackEditOpen() {
        track("edit benchmark", "click", "edit benchmark");
    },
    trackPdfDownload() {
        track("PDF download", "download", "download benchmark", { "file type": "PDF" });
    },
    openSubscriptionModal(isOwner: boolean) {
        track("Subscription Settings", "open", "edit subscription settings", { is_owner: isOwner });
    },
    cancelSubscriptionModal(isOwner: boolean) {
        track("Subscription Settings", "cancel", "edit subscription settings", { is_owner: isOwner });
    },
    confirmSubscriptionModal(frequency, isOwner: boolean) {
        track("Subscription Settings", "save changes", "edit subscription settings", { frequency, is_owner: isOwner });
    },
    unsubscribeFromDigest(isOwner: boolean) {
        track("Subscription Settings", "unsubscribe", "edit subscription settings", { is_owner: isOwner });
    },
});

export default createReportTracking(allTrackers.dispatchTrackEvent.bind(allTrackers));
